module.exports = __webpack_public_path__ + "static/PhoneFrame-5e2304f66c56fd12951f4d73839b9f76.png";